import { Injectable } from '@angular/core';
import { Muteable, MuteableModalProvider } from '../popup/muteable-modal';
import { PriorityLevel } from '../popup/base';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class UnsavedChangesHandlerService {
    constructor(private muteableModalProvider: MuteableModalProvider, private translate: TranslateService) {}

    /**
     * If there are any unsaved changes, prompt the user to continue or keep annotating.
     */
    public async handle(onSaveHandler: Function, isEvaluateWorkspace = false): Promise<boolean> {
        let leave = false;

        const result = await this.muteableModalProvider.createNotification(
            Muteable.LeaveWithoutSaving,
            {
                priority: PriorityLevel.Warning,
                title: this.translate.instant('Unsaved Changes Detected'),
                message: this.translate.instant(
                    'There are unsaved working changes in the current workspace. Would you like to keep these changes?'
                ),
                primaryText: this.translate.instant('Save & Continue'),
                secondaryButtons: [
                    {
                        text: this.translate.instant('Exit Without Saving'),
                        callback: () => {
                            leave = true;
                        }
                    }
                ]
            },
            false,
            isEvaluateWorkspace ? false : true
        );

        if (result && result.primaryClicked) {
            if (onSaveHandler) {
                await onSaveHandler();
            }

            leave = true;
        }

        return leave;
    }
}



// WEBPACK FOOTER //
// ./src/providers/workspace/unsaved-changes-handler.service.ts